//#region Components
import BackToView from "components/BackToView/BackToView";
import HelmetUTP from "components/HelmetUTP/HelmetUTP";
import Preloader from "components/Preloader/Preloader";
import SettingsResourceScheduleAdminContext from "./context/SettingsResourceScheduleAdminContext";
//#endregion
//#region Utils
import ABSOLUTE_PATHS from "routes/utils/absolutePaths";
import useDataRelatedToResourceScheduleAdmin from "./utils/hooks/useDataRelatedToResourceScheduleAdmin";
import useLoadingRequest from "components/Preloader/utils/hooks/useLoadingRequest";
import ScheduleAdminCampusCoordinator from "./ScheduleAdminCampusCoordinator";
import ScheduleAdminGeneralCoordinator from "./ScheduleAdminGeneralCoordinator";
import useDashboardContext from "routes/utils/context/useDashboardContext";
import useResourceModuleIdOfUser from "./utils/hooks/useResourceModuleIdOfUser";
import { USER_ROLES } from "config/userPermissions";
//#endregion

const SettingsResourceScheduleAdmin = ({
    userRole
}) => {
    const isSuperadmin = userRole === USER_ROLES.SUPERADMIN;
    const { userCampusId } = useDashboardContext();
    const loadingRequest = useLoadingRequest();
    const resourceModuleId = useResourceModuleIdOfUser(userRole);
    const data = useDataRelatedToResourceScheduleAdmin({
        loadingRequest, resourceModuleId, userRole, isSuperadmin
    });
    return (
        <>
            <HelmetUTP title="Admin. de horarios" />
            <BackToView to={ABSOLUTE_PATHS.SETTINGS} text="Volver a Configuración" />
            <Preloader {...loadingRequest.value} />
            <SettingsResourceScheduleAdminContext.Provider value={{
                loadingRequest, data, resourceModuleId
            }}>
                {!isSuperadmin && userCampusId
                ? <ScheduleAdminCampusCoordinator campusId={userCampusId}/>
                : <ScheduleAdminGeneralCoordinator/>}
            </SettingsResourceScheduleAdminContext.Provider>
        </>
    );
}

export default SettingsResourceScheduleAdmin;